import { Injectable } from '@angular/core';
import {UserService} from '@sharedcommon/services/user.service';
import {Translation} from 'primeng/api/translation';
import {PrimeNGConfig} from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class PrimengTranslateService {

  /**
   * Frensh translation for the calendar
   */
  calendar_fr: Translation = {
    dayNames: [ "dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi" ],
    dayNamesShort:[ "dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam." ],
    monthNames: [ "janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre" ],
    monthNamesShort: [ "janv.", "févr.", "mars", "avr.", "mai", "juin",
      "juil.", "août", "sept.", "oct.", "nov.", "déc." ],
    dayNamesMin: [ "D","L","M","M","J","V","S" ]
  };

  constructor(
    private readonly userService: UserService,
    private readonly config: PrimeNGConfig
  ) { }


  /**
   * Applies French if the user's language is French, otherwise English.
   */
  applyCalendarLanguage() {
    const lang: string = this.userService.getUser().lang_code ;
    if (lang === 'fr') {
      this.config.setTranslation(this.calendar_fr);
    }
  }
}
